import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PurchaseCancel = () => {
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setTimeout(() => {
            navigate("/");
        }, 5000); // Redirigir después de 5 segundos

        return () => clearTimeout(timer);
    }, [navigate]);

    return (
        <div className="min-h-screen bg-gradient-to-br from-red-50 to-white flex items-center justify-center px-4">
            <div className="max-w-md w-full bg-white rounded-2xl shadow-lg border border-red-100 p-8 text-center">
                {/* Icono de error */}
                <div className="w-20 h-20 mx-auto mb-6 bg-red-100 rounded-full flex items-center justify-center">
                    <svg
                        className="w-10 h-10 text-red-600"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                    >
                        <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>

                {/* Título y mensaje */}
                <h1 className="text-2xl font-bold text-gray-900 mb-4">Pago Fallido</h1>

                <p className="text-gray-600 mb-2">
                    Lo sentimos, no hemos podido procesar tu pago.
                </p>

                <p className="text-gray-500 text-sm mb-8">
                    Serás redirigido automáticamente a la transmisión en vivo en unos
                    segundos.
                </p>

                {/* Botón de reintentar */}
                <button
                    onClick={() => navigate("/checkout")}
                    className="w-full bg-red-600 hover:bg-red-700 text-white font-medium py-3 px-6 rounded-lg transition duration-200 mb-4"
                >
                    Reintentar Pago
                </button>

                {/* Contador de redirección */}
                <div className="mt-6 text-sm text-gray-400">
                    Redirigiendo en 5 segundos...
                </div>
            </div>
        </div>
    );
};

export default PurchaseCancel;
